<app-form-group [classesObj]='{"form-group": !inline, "d-inline": inline}'>
  <app-form-label *ngIf="label">{{label}}</app-form-label>
  <app-form-label *ngIf="customLabel"><ng-content select="[label]"></ng-content></app-form-label>
  <ng-content></ng-content>
  <app-form-help-text [helpText]="helpText"></app-form-help-text>
</app-form-group>